<template>
  <section
    id="partners"
    class="flex-section d-flex flex-column center partners"
  >
    <div class="section-wrapper d-flex flex-column ai-center">
      <div
        class="flex-container ai-center relative mg-100"
        v-bind:class="{ 'mg-50': isMobile }"
      >
        <p class="header-2">Partners /</p>
        <p class="header-2 color-white mask-text">Clients</p>
        <div class="mask-black" />
      </div>
      <ApolloQuery :query="require('../graphql/GetAllPartners.gql')">
        <template slot-scope="{ result: { data }, isLoading }">
          <div
            class="partner-container flex-container wrap mg-150"
            v-bind:class="{ 'mg-50': isMobile }"
          >
            <div v-if="isLoading" class="flex-container center">
              <v-progress-circular color="#1c1c1c" indeterminate />
            </div>
            <template
              v-else
              v-for="(partner, i) in data.GetAllPartners.partners"
            >
              <v-hover v-slot:default="{ hover }" :key="i">
                <div class="partner-cell" v-bind:class="{ active: hover }">
                  <v-img :src="partner.logo" />
                </div>
              </v-hover>
            </template>
          </div>
        </template>
      </ApolloQuery>
      <div class="mg-150" v-bind:class="{ 'mg-50': isMobile }" />
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
};
</script>

<style scoped>
.partners {
  overflow: hidden;
}

.mask-black {
  position: absolute;
  width: 2000px;
  height: 50px;
  top: 0;
  left: 160px;
  background: black;
  z-index: -1;
}

.mask-text {
  margin-left: 15px;
}

.partner-container {
  max-width: 1050px;
}

.partner-cell {
  width: 150px;
  height: 150px;
  border: 1px solid #e9e9e9;
  border-collapse: collapse;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  filter: grayscale(100%);
  transition: 0.3s ease-in-out;
}

.active {
  filter: none;
  transition: 0.3s ease-in-out;
}

@media only screen and (max-width: 880px) {
  .mask-black {
    height: 20px;
    left: 65px;
  }

  .mask-text {
    margin-left: 10px;
  }

  .partner-cell {
    width: 40px;
    height: 40px;
    background-size: contain;
  }
}
</style>
